<script setup lang="ts">
import PTag from 'primevue/tag'
import type { INabooContentLearningCourseChildrenDto } from '@/core/domain/nabooContent/NabooContent.types.ts'
import { computed } from 'vue'
import { NabooContentDiagnostic, NabooContentLearningModule } from '@/core/domain/nabooContent/NabooContent.ts'
import { useRouter } from 'vue-router'
import { useDialog } from 'primevue/usedialog'
import CNabooContentDiagnosticDialog from '@/presentation/components/content/CNabooContentDiagnosticDialog.vue'
import CBaseCard from '@/presentation/components/base/CBaseCard.vue'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'


// PROPS
const props = defineProps<{
  children: INabooContentLearningCourseChildrenDto
}>()

// SERVICES
const router = useRouter()
const dialog = useDialog()

const getSubtitle = computed(() => {
  if (props.children instanceof NabooContentLearningModule) {
    return `Mission ${props.children.order}`
  } else if (props.children instanceof NabooContentDiagnostic) {
    console.log(props.children, 'props.children')
    return props.children.type === QuizType.Values.DIAG_START ? "Test d'entrée" : "Rapport d'exploration"
  } else {
    return ''
  }
})

const getContent = computed(() => {
  if (props.children instanceof NabooContentLearningModule) {
    return `${(props.children as NabooContentLearningModule).countLearningGrains} session(s)`
  } else if (props.children instanceof NabooContentDiagnostic) {
    return `${(props.children as NabooContentDiagnostic).countQuestions} question(s)`
  } else {
    return ''
  }
})

type CardActionObject = {
  label: string
  action: () => void
}

const getFooter = computed<CardActionObject>(() => {
  if (props.children instanceof NabooContentLearningModule) {
    const obj = props.children as NabooContentLearningModule
    return {
      label: 'module',
      action: async () => {
        await router.push({
          name: 'naboo-content-module',
          params: {
            courseId: obj.learningCourseId,
            moduleId: obj.id
          }
        })
      }
    }
  } else if (props.children instanceof NabooContentDiagnostic) {
    return {
      label: 'diagnostic',
      action: async () => {
        const input = props.children as NabooContentDiagnostic
        const blocks = Object.fromEntries(input.tasks.map(task => [task.title, task.quiz?.activeVersion]))
        dialog.open(CNabooContentDiagnosticDialog, {
          props: {
            header: `Parcours - ${input.learningCourseTitle}`,
            modal: true,
            dismissableMask: true,
            draggable: false,
            style: 'width: 50vw',
            breakpoints: {
              '960px': '50vw',
              '640px': '95vw'
            }
          },
          data: {
            blocks: blocks,
            title: input.title
          }
        })
      }
    }
  } else {
    return {
      label: '',
      action: () => {}
    }
  }
})
</script>

<template>
  <c-base-card has-footer class="col-span-3 border border-solid border-black/20 shadow-none">
    <template #header>
      <h5 class="text-surface-900 dark:text-surface-0 font-medium">{{ children.title }}</h5>
      <div class="my-2">
        <p-tag class="uppercase" severity="warn">{{ getSubtitle }}</p-tag>
      </div>
    </template>

    <template #content>
      <p class="text-surface-900 dark:text-surface-0 text-sm italic">{{ getContent }}</p>
    </template>
    <template #footer>
      <button
        class="text-primary-500 cursor-pointer transition-colors duration-200 hover:text-blue-700 focus:outline-none"
        @click="getFooter.action()"
      >
        Voir le contenu du {{ getFooter.label }}
      </button>
    </template>
  </c-base-card>
</template>
